import { render } from "./BaseNotification.vue?vue&type=template&id=544b42f8"
import script from "./BaseNotification.vue?vue&type=script&lang=ts"
export * from "./BaseNotification.vue?vue&type=script&lang=ts"
script.render = render

export default script